import styled from 'styled-components'

export const Container = styled.div`
  align-self: stretch;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
`

export const Header = styled.div`
  padding: 0.5vw 1vw;
  display: flex;
  align-items: center;
  gap: 1vw;
  ${({ theme: { colors } }) => `
    color: ${colors('background')};
    background: ${colors('link')};
  `}
`

export const Mode = styled.span`
  font-size: 1.5vw;
  font-weight: 700;
  padding: 0 0.6vw;
  border: 0.15vw solid currentColor;
  border-radius: 0.4vw;
`

export const StopName = styled.div`
  flex: 1;
  min-width: 0;
  font-size: 2vw;
  font-weight: 600;
`

export const Distance = styled.div`
  font-size: 1.3vw;
  opacity: 0.85;
`

export const Arrivals = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  padding: 0.5vw 1vw;
`

export const Arrival = styled.div`
  display: flex;
  align-items: center;
  gap: 1vw;
  font-size: 1.8vw;
`

export const Route = styled.span`
  flex: none;
  min-width: 5vw;
  text-align: center;
  font-weight: 700;
  padding: 0.2vw 0.8vw;
  border-radius: 0.5vw;
  ${({ $bg, $fg, theme: { colors } }) => `
    background: ${$bg || colors('chrome')};
    color: ${$fg || colors('text')};
  `}
`

export const Destination = styled.span`
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Minutes = styled.span`
  flex: none;
  font-weight: 600;
  ${({ $delayed, theme: { colors } }) => `
    color: ${$delayed ? colors('danger') : colors('link')};
  `}
`

export const Dots = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.5vw;
  padding-bottom: 0.6vw;
`

export const Dot = styled.span`
  width: 0.7vw;
  height: 0.7vw;
  border-radius: 50%;
  ${({ $active, theme: { colors } }) => `
    background: ${$active ? colors('link') : colors('chrome')};
  `}
`

export const Empty = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 1rem;
  font-size: 1.5vw;
  font-style: oblique;
  ${({ theme: { colors } }) => `
    color: ${colors('neutral')};
  `}
`
